<template>
  <div :class="{'business-alias-list': scroll}">
    <InputText
      v-for="(alias, index) in businessAliases"
      :id="`enhancedBusinessAlias${index + 1}`"
      :key="index"
      v-model.trim="businessAliases[index].value"
      :label="`Business Alias ${index+1}`"
      :placeholder="`Business Alias ${index+1}`"
      :name="`business-alias-${index+1}`"
      class="mt-5"
      :has-error="errors[`businessAlias${index+1}`] &&
        errors[`businessAlias${index+1}`].hasError"
      @blur="analytics.input.businessAlias(`${index+1}`)"
    >
      <span
        v-if="errors[`businessAlias${index+1}`] &&
          errors[`businessAlias${index+1}`].hasError"
        slot="helper"
      >
        {{ errors[`businessAlias${index+1}`].message }}
      </span>
    </InputText>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  InputText,
} from '@mgo/ui/lib/components';
import { attachFieldErrors } from '@mgo/core/src/validations/stringValidator';
import { object } from 'yup';
import {
  multiBusinessAlias,
} from '@mgo/core/src/validations/coa';
import { mapDeepErrors, objectIsValid } from '@mgo/core/src/validations/utils';

export default {
  name: 'BusinessAlias',
  components: {
    InputText,
  },
  props: {
    initialAliasCount: {
      type: Number,
      default: 4,
      required: false,
    },
    aliasesIncrement: {
      type: Number,
      default: 4,
      required: false,
    },
    maxAliasCount: {
      type: Number,
      default: 4,
      required: false,
    },
    analytics: {
      type: Object,
      required: true,
    },
    fieldError: {
      type: Array,
      required: false,
      default: () => {},
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    businessName: {
      type: String,
      required: false,
      default: '',
    },
    scroll: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      fieldErrors: this.fieldError,
      lazy: true,
      businessAliases: this.value,
      businessAliasValidator: [],
    };
  },
  computed: {
    additionalAlias() {
      const increment = this.businessAliases.length < this.initialAliasCount
        ? this.initialAliasCount : this.aliasesIncrement;
      return this.businessAliases.length + this.aliasesIncrement < this.maxAliasCount
        ? increment : this.maxAliasCount - this.businessAliases.length;
    },
    rules() {
      const validSchema = this.businessAliasValidator
        .reduce((acc, curr, index) => {
          acc[`businessAlias${index + 1}`] = curr;
          return acc;
        }, {});
      return object().shape(validSchema);
    },
    errors() {
      if (this.fieldErrors?.length !== 0) {
        // do nothing - only serves to force validation
      }
      const errs = mapDeepErrors(this, this.businessAliases,
        this.businessAliasValidator.map((v, index) => `businessAlias${index + 1}`));
      return errs;
    },

  },
  watch: {
    fieldError: {
      handler(newValue) {
        this.fieldErrors = newValue;
      },
      deep: true,
    },
    businessAliases: {
      handler() {
        this.lazy = false;
      },
      deep: true,
    },
    value: {
      handler(newValue) {
        this.businessAliases = newValue;
        if (!this.businessAliases.length) {
          this.expandBusinessAlias();
        }
      },
      deep: true,
    },
  },
  mounted() {
    // extend validator to aliases retrieve from database
    this.businessAliases.forEach((v, i) => {
      this.addValidator(i + 1);
    });

    // add on enough empty alias
    if (!this.businessAliases.length) {
      this.expandBusinessAlias();
    }
  },
  methods: {
    attachFieldErrors,
    expandBusinessAlias() {
      Array.from(Array(this.additionalAlias).keys()).forEach(() => {
        this.businessAliases.push({ value: '' });
        this.addValidator(this.businessAliases.length);
      });
    },
    moreAlias() {
      this.expandBusinessAlias();
    },
    focus() {
      this.$nextTick(() => {
        const index = this.businessAliases.length;

        const alias = document.getElementById(`business-alias-${index}`);

        if (alias) {
          const scrollIntoViewOptions = { behavior: 'smooth', block: 'nearest' };
          alias.scrollIntoView(scrollIntoViewOptions);
        }
      });
    },
    addValidator(index) {
      const newValid = multiBusinessAlias
        .clone()
        .requestFieldValidation('aliases')
        .label(`Business Alias ${index}`);

      // this.businessAliasValidator.push(newValid);
      // commented up above doesn't work since vue can't
      // track changes in an array on computed variables
      Vue.set(this.businessAliasValidator, this.businessAliasValidator.length, newValid);
    },
    isValid() {
      const valid = objectIsValid(this.errors) && !this.fieldErrors?.length;
      return valid;
    },
  },
};
</script>

<style>
  /* adds scroll functionality to alias window */
  .business-alias-list {
    max-height: 450px;
    overflow-y: scroll;
    padding-right: 17px;
  }

  .business-alias-list .c-input-text:first-child {
    margin-top: 0;
  }
</style>
